<template>
  <v-col
    cols="12"
    sm="6"
    offset-sm="3"
  >
    <v-card>
      <v-toolbar color="cyan">
        <v-toolbar-title>Todo List</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <add-activity-field ref="inputFeild" />
        <v-list subheader>
          <activity
            v-for="(activity, index) in activities"
            :key="index"
            :activity="activity"
          />
        </v-list>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
  import Activity from './Activity'
  import AddActivityField from './AddActivityField'

  export default {
    name: 'ActivitiesList',
    components: {
      Activity,
      AddActivityField,
    },
    data () {
      return {}
    },
    computed: {
      activities () {
        return this.$store.state.activities
      },
    },
    methods: {
      add () {
        this.$refs.inputFeild.add()
      },
    },
  }
</script>

<style>
</style>
